<template>
  <div class="spinner" />
</template>

<style scoped>
  .spinner {
    border: 5px solid #f3f3f3; /* Light grey */
    border-top: 5px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 1.2em;
    height: 1.2em;
    padding: 0;
    display: inline-block;
    /*margin-left: auto;*/
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
